<template>

  <el-dialog title="登录"
             :visible.sync="box"
             modal-append-to-body
             append-to-body
             width="30%">
    <el-tag type="danger">
      请使用BladeX商业帐号密码登录，帐号密码请见授权邮件，新用户请 <a href="#" @click="handleVip">前往获取授权</a>
    </el-tag>
    <el-tag type="danger">
      若忘记密码请用授权邮箱 <a href="#" @click="handleReset">前往重置密码</a>。 遇到问题请联系官方 bladejava@qq.com
    </el-tag>
    <br/> <br/>
    <el-form ref="form"
             :rules="rules"
             :model="form"
             label-width="80px">
      <el-form-item label="用户名"
                    prop="username">
        <el-input :disabled="disabled"
                  v-model="form.username"></el-input>
      </el-form-item>
      <el-form-item label="密码"
                    prop="password">
        <el-input :disabled="disabled"
                  v-model="form.password"
                  type="password"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button :disabled="disabled"
                   type="primary"
                   @click="handleLogin">登录
        </el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
  import {mapState} from 'vuex'

  export default {
    data() {
      return {
        form: {},
        disabled: false,
        rules: {
          username: [
            {required: true, message: '请输入用户名', trigger: 'change'}
          ],
          password: [
            {required: true, message: '请输入用密码', trigger: 'change'}
          ]
        },
        box: false
      }
    },
    computed: {
      ...mapState(['user']),
    },
    created() {
      if (!this.validatenull(this.user)) {
        this.handleSuccess();
      }
    },
    methods: {
      handleVip() {
        this.box = false;
        this.$router.push({
          path: '/vip',
        })
      },
      handleReset() {
        this.box = false;
        window.location.href = "https://center.javablade.com/user/forgot_password"
      },
      handleOpen() {
        this.box = true;
      },
      handleSuccess() {
        this.box = false;
        this.$emit('submit');
      },
      handleLogin() {
        this.disabled = true;
        const username = this.form.username.replace("@qq.com", "");
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.$httpajax.post(this.website.GIT.loginurl, {
              username: username,
              password: this.form.password
            }).then(res => {
              const flag = res.data.flag;
              const msg = res.data.msg
              if (flag) {
                this.disabled = false;
                this.$store.commit('setUser', username)
                this.$store.commit('setToken', msg)
                this.$message.success({message: '登录成功，欢迎回来', offset: 60})
                this.handleSuccess();
              } else {
                this.disabled = false;
                this.$message.error(msg)
              }

            }).catch(err => {
              this.disabled = false;
              this.$message.error(err.error)
            });
          }
        });
      },
    }
  }
</script>

<style>
</style>
